import { z } from 'zod';

export const folderSchema = z.object({
  name: z
    .string()
    .min(1, 'نام فولدر الزامی است')
    .min(2, 'نام فولدر باید حداقل ۲ کاراکتر باشد')
    .max(100, 'نام فولدر نباید بیشتر از ۱۰۰ کاراکتر باشد'),
});
